import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'components/legacy/Card';
import { H1, Paragraph } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';

import MapPin from 'components/svg/MapPin';

import './PLPHero.scss';

export function PLPHero({ storageType, handleSearch = () => {} }) {
	return (
		<Card className="plp-hero">
			<H1
				size="large"
				family="rounded"
				weight="bold"
			>
				Find {storageType} Storage Near You
			</H1>
			<Paragraph
				size="small"
				color="gray"
				weight="standard"
			>
				Make a free reservation in minutes!
			</Paragraph>
			<SearchBox
				defaultButton={false}
				icon={<MapPin />}
				id="hero-search"
				inputLabel="Enter address, city, or zip code"
				onSearch={handleSearch}
				useBrowserLocation
			/>
		</Card>
	);
}

PLPHero.propTypes = {
	storageType: PropTypes.string,
	handleSearch: PropTypes.func,
};
